var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.avatarType !== null && _vm.deviceModeIcons[_vm.avatarType])?_c('Icon',{staticClass:"device-avatar",attrs:{"type":_vm.deviceModeIcons[_vm.avatarType],"st":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }